export interface Me { account: { id: string; email: string; displayName: string; avatarVersion: string | null; isAdmin: boolean }; workspace: { id: string; name: string }; csrfToken: string | null; }
let csrf = "";
const TOKEN_STORAGE = "uh_display_token";

export function setCsrf(value: string | null): void { csrf = value ?? ""; }

/** Display tokens are read-only credentials handed to a paired screen; never used for writes. */
export function getDisplayToken(): string {
  try { return window.localStorage.getItem(TOKEN_STORAGE) ?? ""; } catch { return ""; }
}

export function setDisplayToken(value: string | null): void {
  try { value ? window.localStorage.setItem(TOKEN_STORAGE, value) : window.localStorage.removeItem(TOKEN_STORAGE); } catch { /* storage may be blocked */ }
}

/** Reads a token from the URL fragment (preferred: fragments never reach the server logs) or query. */
export function captureToken(): string | null {
  if (typeof window === "undefined") return null;
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  return hash.get("token") ?? query.get("token") ?? null;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.method && !["GET", "HEAD"].includes(init.method)) headers.set("x-csrf-token", csrf);
  const token = getDisplayToken();
  if (token) headers.set("authorization", `Bearer ${token}`);
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  if (response.status === 204) return undefined as T;
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) throw new Error(typeof body === "object" && body && "error" in body ? String((body as { error: { message: string } }).error.message) : "Request failed");
  return body as T;
}
